module.exports = __webpack_public_path__ + "media/images/homepage/reason-5-29a90f4b78fad5c4de5e210eaeb6ee9b.png";